module.exports = __webpack_public_path__ + "img/132.743645fe.jpg";